import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("nl_cookie_consent")) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("nl_cookie_consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          role="dialog"
          aria-label="Συγκατάθεση cookies"
          data-testid="cookie-banner"
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[75] bg-ink text-cream p-6 sm:p-7 border border-cream/15 shadow-2xl"
        >
          <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-terracotta">Cookies</p>
          <p className="text-sm text-cream/85 leading-relaxed mt-3">
            Χρησιμοποιούμε απολύτως απαραίτητα cookies για τη λειτουργία του site και — μόνο με τη συγκατάθεσή σου — cookies
            ανάλυσης για να το βελτιώνουμε.
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <button
              onClick={() => choose("all")}
              data-testid="cookie-accept-all"
              className="bg-terracottaD text-cream text-sm font-medium px-5 py-2.5 rounded-full transition-colors duration-300 hover:bg-cream hover:text-ink"
            >
              Αποδοχή όλων
            </button>
            <button
              onClick={() => choose("essential")}
              data-testid="cookie-essential-only"
              className="border border-cream/30 text-cream text-sm font-medium px-5 py-2.5 rounded-full transition-colors duration-300 hover:border-terracotta"
            >
              Μόνο απαραίτητα
            </button>
            <button
              onClick={() => choose("rejected")}
              data-testid="cookie-reject-all"
              className="text-cream/70 text-sm font-medium px-5 py-2.5 rounded-full transition-colors duration-300 hover:text-cream"
            >
              Απόρριψη
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
